export default function (value) {
  if (!value) {
    return true;
  }

  value = value.toLowerCase();

  let threeCharacterRepetitionPattern = /(.)\1{2}/;
  let hasThreeCharacterSequence = false;

  for (var i in value) {
    if (
      String.fromCharCode(value.charCodeAt(i) + 1) == value[+i + 1] &&
      String.fromCharCode(value.charCodeAt(i) + 2) == value[+i + 2]
    ) {
      hasThreeCharacterSequence = true;
    }
  }

  if (hasThreeCharacterSequence || threeCharacterRepetitionPattern.test(value)) {
    return false;
  }

  return true;
};
